import { createFileRoute } from "@tanstack/react-router";
import { useTicketTypeDrawerContext } from "@/utils/ticket-type-detail/ticket-type-drawer-context";
import { TicketTypeLifecycleSection } from "./fullLifecycle";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/ticketTypes/$ticketTypeId/lifecycle",
)({
	component: OrgTicketTypeLifecycleTab,
});

function OrgTicketTypeLifecycleTab() {
	const { ticketType } = useTicketTypeDrawerContext();

	return (
		<div className="px-5 pb-5">
			<TicketTypeLifecycleSection
				ticketType={ticketType}
				scope="organization"
			/>
		</div>
	);
}
